import React, { type JSX, type ReactNode } from "react";

export type AdminFilterBarItem = {
  control: ReactNode;
  id: string;
  label: string;
};

export type AdminFilterBarProps = {
  actions?: ReactNode;
  items: AdminFilterBarItem[];
};

export function AdminFilterBar(props: AdminFilterBarProps): JSX.Element {
  return (
    <section
      style={{
        padding: "16px",
        borderRadius: "22px",
        background: "rgba(255, 255, 255, 0.82)",
        border: "1px solid rgba(24, 33, 43, 0.08)",
        boxShadow: "0 18px 36px rgba(15, 23, 42, 0.08)",
      }}
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
          gap: "12px",
        }}
      >
        {props.items.map((item) => (
          <label
            htmlFor={item.id}
            key={item.id}
            style={{
              display: "grid",
              gap: "6px",
            }}
          >
            <span
              style={{
                color: "#64748b",
                fontSize: "0.78rem",
                fontWeight: 700,
                letterSpacing: "0.08em",
                textTransform: "uppercase",
              }}
            >
              {item.label}
            </span>
            {item.control}
          </label>
        ))}
      </div>

      {props.actions ? <div style={{ marginTop: "12px" }}>{props.actions}</div> : null}
    </section>
  );
}
